import React from 'react';
import type { PreviewColorScheme } from '../WebsitePreview';

const DashboardPreview: React.FC<{ scheme: PreviewColorScheme }> = ({ scheme }) => (
  <div style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: '12px', display: 'flex', minHeight: '320px' }}>
    {/* Sidebar */}
    <div style={{ width: '160px', backgroundColor: scheme.text, padding: '14px 10px', flexShrink: 0 }}>
      <div style={{ color: '#fff', fontWeight: 700, fontSize: '13px', marginBottom: '16px', paddingLeft: '6px' }}>Sample dashboard</div>
      {['Overview', 'Analytics', 'Projects', 'Team', 'Settings'].map((item, i) => (
        <div
          key={item}
          style={{
            padding: '7px 10px',
            borderRadius: '5px',
            color: i === 0 ? '#fff' : 'rgba(255,255,255,0.55)',
            backgroundColor: i === 0 ? scheme.primary : 'transparent',
            fontWeight: i === 0 ? 600 : 400,
            fontSize: '11px',
            marginBottom: '2px',
          }}
        >
          {item}
        </div>
      ))}
    </div>

    {/* Main */}
    <div style={{ flex: 1, padding: '16px', backgroundColor: scheme.background }}>
      {/* Top bar */}
      <div className="flex items-center justify-between" style={{ marginBottom: '14px' }}>
        <div style={{ fontWeight: 700, color: scheme.text, fontSize: '15px' }}>Overview</div>
        <div style={{ backgroundColor: scheme.primary, color: '#fff', padding: '4px 12px', borderRadius: '5px', fontSize: '11px', fontWeight: 600 }}>
          New Report
        </div>
      </div>

      {/* Stat Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '14px' }}>
        {[
          { label: 'Reading text', value: 'Aa Bb', change: 'Example annotation' },
          { label: 'Surface', value: 'Card', change: 'Supporting label' },
          { label: 'Emphasis', value: 'Accent', change: 'State label' },
        ].map(s => (
          <div key={s.label} style={{ backgroundColor: scheme.surface, border: `1px solid ${scheme.border}`, borderRadius: '8px', padding: '12px' }}>
            <div style={{ color: scheme.textMuted, fontSize: '10px', marginBottom: '4px' }}>{s.label}</div>
            <div style={{ color: scheme.text, fontWeight: 700, fontSize: '16px' }}>{s.value}</div>
            <div style={{ color: scheme.secondary, fontSize: '10px', fontWeight: 600 }}>{s.change}</div>
          </div>
        ))}
      </div>

      {/* Chart placeholder */}
      <div style={{ backgroundColor: scheme.surface, border: `1px solid ${scheme.border}`, borderRadius: '8px', padding: '12px' }}>
        <div style={{ color: scheme.text, fontWeight: 600, fontSize: '12px', marginBottom: '10px' }}>Sample chart</div>
        <div className="flex items-end gap-2" style={{ height: '60px' }}>
          {[40, 65, 50, 80, 55, 70, 90].map((h, i) => (
            <div key={i} style={{ flex: 1, height: `${h}%`, backgroundColor: i === 6 ? scheme.primary : scheme.secondary, borderRadius: '3px', opacity: i === 6 ? 1 : 0.6 }} />
          ))}
        </div>
        <div className="flex justify-between" style={{ marginTop: '4px' }}>
          {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(d => (
            <span key={d} style={{ fontSize: '9px', color: scheme.textMuted, flex: 1, textAlign: 'center' }}>{d}</span>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default DashboardPreview;
